/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyEventBoard', DinghyEventBoard);

    DinghyEventBoard.$inject = ['$resource', 'DateUtils'];

    function DinghyEventBoard ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghy-events/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fromDate = DateUtils.convertDateTimeFromServer(data.fromDate);
                        data.untilDate = DateUtils.convertDateTimeFromServer(data.untilDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.additionalFromDates) {
                        for(var i = 0; i < copy.additionalFromDates.length; i++) {
                            copy.additionalFromDates[i] = DateUtils.convertLocalDateToServer(copy.additionalFromDates[i]);
                        }
                    }
                    return angular.toJson(copy);
                }
            }
        });
    }
})();
